import lottie from 'lottie-web'
// анимации шагов оффера: Parcel копирует файлы как есть и подставляет их адреса, загружаем обычным fetch
// (динамический import() JSON без анимации первого экрана в точке входа на стейдже не срабатывал)
import offer1 from '../../assets/animations/v2/offer-step-1.lottiejson'
import offer2 from '../../assets/animations/v2/offer-step-2.lottiejson'
import offer3 from '../../assets/animations/v2/offer-step-3.lottiejson'
import offer4 from '../../assets/animations/v2/offer-step-4.lottiejson'

const steps = [offer1, offer2, offer3, offer4].map((url) => () => fetch(url).then((r) => r.json()))
const data = m => JSON.parse(JSON.stringify(m.default || m))

// шаги оффера грузятся после анимации первого экрана, чтобы не отнимать у неё сеть.
// Если Lottie-анимации первого экрана на странице нет (лёгкая HTML-версия), шаги грузятся сразу.
let heroDone
const heroReady = new Promise((resolve) => { heroDone = resolve })
let heroStarted = false

// интерфейс платформы в первом экране (Lottie; в текущих версиях не используется)
export const initHero = (load) => {
  heroStarted = true
  const box = document.getElementById('ui')
  if (!box) { heroDone(); return }
  load().catch((e) => { heroDone(); throw e }).then((m) => {
    const a = lottie.loadAnimation({
      container: box,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      initialSegment: [10, 771],
      animationData: data(m),
      rendererSettings: { preserveAspectRatio: 'xMidYMid slice', progressiveLoad: false },
    })
    a.addEventListener('DOMLoaded', () => {
      heroDone()
      // анимация отрисовала первый кадр — плавно убираем заглушку
      requestAnimationFrame(() => requestAnimationFrame(() => box.classList.add('ready')))
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((es) => { if (es[0].isIntersecting) a.play(); else a.pause() }, { threshold: 0.15 }).observe(box)
      } else a.play()
    })
  })
}

// шаги оффера: анимация идёт, пока курсор на карточке (на телефоне — один раз при появлении)
export const initOfferSteps = () => {
  if (!heroStarted) heroDone()   // первого экрана на Lottie нет — ждать нечего
  const wrap = document.getElementById('ofx')
  if (!wrap) return
  const SEG = [[10, 31, 106, 127], [8, 29, 130, 151], [8, 29, 104, 125], [8, 29, 81, 102]]
  const cards = [].slice.call(wrap.children)
  const A = []
  const touch = window.matchMedia('(hover:none)').matches
  cards.forEach((c, k) => {
    c.classList.add('on')
    const st = { a: null, want: false, playing: false }
    A.push(st)
    st.start = () => {
      st.want = true
      if (!st.a || st.playing) return
      st.playing = true; st.a.loop = true; st.a.goToAndPlay(0, true)
    }
    c.addEventListener('pointerenter', () => st.start())
    c.addEventListener('pointerleave', () => { st.want = false })
    heroReady.then(steps[k]).then((m) => {
      const d = data(m); d.ip = SEG[k][1]; d.op = SEG[k][2]
      const a = lottie.loadAnimation({ container: document.getElementById(`of-a${k}`), renderer: 'svg', loop: false, autoplay: false, animationData: d })
      st.a = a
      a.addEventListener('DOMLoaded', () => { a.goToAndStop(0, true); if (st.want) { st.want = false; st.start() } })
      a.addEventListener('loopComplete', () => { if (!st.want) { a.loop = false; a.goToAndStop(0, true); st.playing = false } })
    })
  })
  if (!touch || !('IntersectionObserver' in window)) return
  cards.forEach((c, k) => {
    new IntersectionObserver((es) => {
      if (es[0].isIntersecting) { A[k].start(); setTimeout(() => { A[k].want = false }, 300) }
    }, { threshold: 0.6 }).observe(c)
  })
}
